__webpack_require__.p = "https://www.hukumonline.com/pusatdata/detail/_next/";